<template>
  <div class="hotel-list-search-bar" data-component="hotel-list-search-bar">
    <input class="search-input icon-search" :placeholder="tc('booking.findYourDestination')" value="" @input="triggerFilter" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters('i18n', ['tc'])
  },
  methods: {
    triggerFilter (val) {
      this.$emit('filter-items', val.currentTarget.value, 'input');
    }
  }
}
</script>